import { LOGIN_FAIL, LOGIN_SUCCESS, SET_LOADER } from '../types/authTypes'
import Cookies from 'js-cookie'

const initialState = {
	accessToken: Cookies.get('ClaccessToken') || null,
	idToken: Cookies.get('ClidToken') || null,
	email: Cookies.get('Clemail') || null,
	firstName : Cookies.get('ClfirstName') || null,
	status: Cookies.get('Clstatus') || null,
	role : Cookies.get('Clrole') || null,
	EmployeeId: Cookies.get('EmployeeId') || null , 
	isAuthenticated: Cookies.get('ClisAuthenticated') || false,
	message: null,
}

const authReducer = (state = initialState, action) => {
	const { type, payload } = action
	console.log('*&* auth Reducer Payload : ', payload, type);
	switch (type) {
		case SET_LOADER:
			return { ...state, loading: payload }
		case LOGIN_SUCCESS:
			console.log('*&* auth reducer return value : ', {
			    ...payload.data,
				loading: false,
				isAuthenticated: true,
				idToken : payload?.data?._id,
				status : payload?.data?.status,
				role : payload?.data?.role,
				accessToken : payload?.data?.token
			});
			return { 
				...payload.data,
				loading: false,
				isAuthenticated: true,
				idToken : payload?.data?._id,
				status : payload?.data?.status,
				role : payload?.data?.role,
				accessToken : payload?.data?.token, 
				EmployeeId:(payload?.data?.employee?._id || null)
			}
		case LOGIN_FAIL:
			return { ...initialState, loading: false, isAuthenticated: false }
		default:
			return state
	}
}

export default authReducer
